<template>
  <div class="container-fluid main_content">
    <!--<div
      style="background-image: url('/img/sample/LIST.png');height: 850px;width:335px;background-repeat: no-repeat;opacity:0.5;
      position:absolute;top:63px;left:105px;"></div>-->
    <car-list-box style="float: left;" @selectDay="selectDay" @lastGpsSelected="lastGpsSelected" @reInit="reInit"/>
    <!-- <div class="map">

     </div>-->
    <kakao-map class="map"
               :value = "this.positions"
               :lastGps = "this.lastGps"
               @load="onMapLoad"
    />
    <div class="selected_car_list_box" :class="{'folding':folding}">
      <div class="close_btn_area" @click="foldingClick">
        <img class="close_btn" src="/img/icon/table_down.png" height="20" width="40"/>
      </div>
      <car-selected-list v-model="locations" :class="{'folding':folding}" @locationSelected="locationSelected" @dataSelected="dataSelected"/>
    </div>
  </div>
</template>

<script>
import CarListBox from '@/components/CarListBox'
import CarDataBox from '@/components/CarDataBox'
import CarSelectedList from '@/components/CarSelectedList'
import KakaoMap from '@/components/KakaoMap'
import counterClockWise from '@/mixin/counterClockWise'
import ax from '@/api/location'

export default {
  name: 'Drive',
  components: {
    CarListBox,
    CarSelectedList,
    KakaoMap,
    CarDataBox
  },
  mixins: [
    counterClockWise
  ],
  data () {
    return {
      locations: { id: null, date: null },
      loading: false,
      folding: false,
      mapObject: null,
      positions: {},
      lastGps: {},
      datas: null,
    }
  },
  
  methods: {
    onMapLoad (map) {
      // 지도의 현재 영역을 얻어옵니다
      let bounds = map.getBounds()
      // 영역정보를 문자열로 얻어옵니다. ((남,서), (북,동)) 형식입니다
      let boundsStr = bounds.toString()
      // console.log('Daum Map Loaded', boundsStr)
      this.mapObject = map
    },
    selectDay (id, date) {
      this.locations = { id: id, date: date }
      if (this.folding) {
        this.folding = !this.folding
      }
    },
    locationSelected (targetLocation) {
      this.mapShow = false
      this.dataShow = true

      ax.mapLocations(targetLocation, response => {
        if (response) {
          let sPoint = {x: response.sdata.lng, y: response.sdata.lat}
          let ePoint = {x: response.edata.lng, y: response.edata.lat}
          
          
          let sdata_isCross =this.getCrossPoint(null, sPoint)
          let edata_isCross =this.getCrossPoint(null, ePoint)
          
          if(sdata_isCross || edata_isCross) {
            if(sdata_isCross) response.sdata = response.data[0]
            if(edata_isCross) response.sdata = response.data[response.data.len]
          }
          
          this.positions = response
        } else {
          this.positions = {}
        }
      })
    },
    dataSelected (targetData) {
      this.$router.push({ name:'DataList', params: { value : targetData } })
    },

    lastGpsSelected (addr, gps_y, gps_x, c_date) {
      if(gps_y == null && gps_y == "" || gps_x == null && gps_x == "") {
        this.lastGps = {}
      } else {
        this.lastGps = { addr: addr, y: gps_y, x: gps_x, c_date: c_date }
      }
    },

    foldingClick () {
      this.folding = !this.folding
    },

    reInit() {
      this.positions = null
      this.lastGps = null
    }
  }
}
</script>

<style lang="scss" scoped>
.map {
  margin-left: 335px;
  height: calc(100vh - 64px);
  background-image: url('/img/sample/map.png');
  background-repeat: repeat;
  /*min-width: 840px;*/
  z-index: 0;
}

.selected_car_list_box {
  position: absolute;
  left: 440px;
  bottom: 0px;
  width: calc(100% - 440px);
  min-width: 840px;
  background: #FFFFFF;
  border-radius: 12px 12px 0px 0px;
  padding: 20px 15px 15px 15px;
  z-index: 10;

  .close_btn_area .close_btn {
    position: absolute;
    left: 50%;
    top: -20px;
    margin-left: -20px;
    cursor: pointer;
  }

  &.folding {
    padding: 0px;

    .folding {
      display: none;
    }
  }
}
</style>
